(() => {
  const settings = window.themeMotionSettings || {};
  const aosSettings = settings.aos || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let lenis;
  let aosInitialized = false;

  const designMode = () => Boolean(window.Shopify && Shopify.designMode);

  const destroySmoothScroll = () => {
    if (!lenis) return;

    lenis.destroy();
    lenis = undefined;
    delete window.themeLenis;
  };

  const initializeSmoothScroll = () => {
    destroySmoothScroll();

    if (!settings.smoothScroll || reducedMotion.matches || designMode() || typeof Lenis === 'undefined') return;

    lenis = new Lenis({
      anchors: true,
      autoRaf: true,
      autoToggle: true,
      smoothWheel: true,
      stopInertiaOnNavigate: true,
      allowNestedScroll: true,
    });

    window.themeLenis = lenis;
  };

  const getAosTargets = (root = document) =>
    Array.from(document.querySelectorAll('#MainContent > .shopify-section')).filter(
      (section) => root === document || section === root || root.contains(section)
    );

  const applyAosAttributes = (root = document) => {
    getAosTargets(root).forEach((section) => {
      if (section.hasAttribute('data-aos-ignore') || section.hasAttribute('data-aos')) return;

      const animation = aosSettings.animation === 'alternating' ? 'fade-up' : aosSettings.animation || 'fade-up';
      section.setAttribute('data-aos', animation);
      section.setAttribute('data-theme-aos', 'true');
    });
  };

  const initializeAos = () => {
    if (!aosSettings.enabled || reducedMotion.matches || typeof AOS === 'undefined') return;

    applyAosAttributes();
    AOS.init({
      offset: Number(aosSettings.offset),
      delay: Number(aosSettings.delay),
      duration: Number(aosSettings.duration),
      easing: aosSettings.easing,
      once: Boolean(aosSettings.once),
      mirror: !Boolean(aosSettings.once),
      anchorPlacement: aosSettings.anchorPlacement,
      disableMutationObserver: false,
    });
    aosInitialized = true;
  };

  const refreshAos = (root = document) => {
    if (!aosInitialized) return;

    applyAosAttributes(root);
    requestAnimationFrame(() => AOS.refreshHard());
  };

  const initializeMotion = () => {
    initializeSmoothScroll();

    if (!aosInitialized) initializeAos();
    else AOS.refreshHard();
  };

  initializeMotion();
  reducedMotion.addEventListener('change', initializeMotion);

  if (designMode()) {
    document.addEventListener('shopify:section:load', (event) => refreshAos(event.target));
    document.addEventListener('shopify:section:reorder', () => refreshAos());
  }
})();